export enum StationType {
    CURRENT = "currentStation",
    PREVIOUS = "previousStation"
}